module.exports = __webpack_public_path__ + "static/media/12603890-preview.548a361a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/12603890-preview.mp4
// module id = 1815
// module chunks = 0